import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { AdminAdminsListing } from './admins';
import { AdminTutorsListing } from './tutors';
import { AdminStudentsListing } from './student';

export const UsersListing = () => {
  const tabData = [
    {
      name: "Students",
      key: "students",
      component: <AdminStudentsListing />
    },
    {
      name: "Tutors",
      key: "tutors",
      component: <AdminTutorsListing />
    },
    {
      name: "Admins",
      key: "admins",
      component: <AdminAdminsListing />
    },
  ];

  const [activeTab, setActiveTab] = useState(tabData[0].key);

  const handleSelect = (key) => {
    setActiveTab(key);
  };

  const activeContent = tabData.find(tab => tab.key === activeTab)?.component;

  return (
    <>
      <Nav
        variant="pills"
        activeKey={activeTab}
        onSelect={handleSelect}
        className="p-2 light bg-white rounded-top"
      >
        {tabData.map((tab, index) => (
          <Nav.Item key={index}>
            <Nav.Link eventKey={tab.key}>{tab.name}</Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      <div className="p-3 bg-white rounded-bottom">
        {activeContent}
      </div>
    </>
  );
};